import { createFileRoute } from '@tanstack/react-router'

import EditPenyuluh from '@/components/pages/backoffice/edit-penyuluh/containers/EditPenyuluh'

export const Route = createFileRoute('/_backoffice/edit-penyuluh/')({
  component: EditPenyuluh
})
